import React, { useEffect, useState, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { Field, reduxForm } from 'redux-form';
import { ButtonToolbar, Button, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import Select from '../../../shared/components/form/Select';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';

const SchoolClassFilter = (props) => {
  const { t, filterClick, initialize, lastFilter, courses, team } = props;
  const [filter, setFilter] = useState();

  const filterChange = (field, value) => {
    const updatedFilter = { ...filter };
    updatedFilter[field] = value;
    setFilter(updatedFilter);
  };

  const filterCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      setFilter(updatedFilter);
    }
  };

  useEffect(() => {
    setFilter(lastFilter);
    initialize(lastFilter);
  }, [lastFilter]);

  return (
    <MuiThemeProvider>
      <Fragment>
        <div className="form">
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.year-level')}
            </span>
            <div className="form__form-group-field">
              <Field
                name="courseStep"
                component={Select}
                options={courses}
                placeholder={t('general.placeholders.select')}
                onChange={(value) => filterChange('courseStep', value)}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.team')}</span>
            <div className="form__form-group-field">
              <Field
                name="team"
                component={Select}
                isMulti
                closeMenuOnSelect={false}
                options={team}
                placeholder={t('general.placeholders.select')}
                onChange={(value) => filterChange('team', value)}
              />
            </div>
          </div>
          <div className="form__form-group-field">
            <Field
              name="active"
              component={renderCheckBoxField}
              defaultValue
              className="colored-click"
              onChange={filterCheckChange}
            />
            <Label className="generic__label">{t('general.only-active')}</Label>
          </div>
        </div>
        <ButtonToolbar
          className="form__button-toolbar"
          style={{ justifyContent: 'flex-end' }}
        >
          <Button color="success" onClick={() => filterClick(filter)}>
            {t('general.filter')}
          </Button>
        </ButtonToolbar>
      </Fragment>
    </MuiThemeProvider>
  );
};

SchoolClassFilter.propTypes = {
  t: PropTypes.func.isRequired,
  filterClick: PropTypes.func.isRequired,
  initialize: PropTypes.func.isRequired,
  lastFilter: PropTypes.shape(
    PropTypes.shape({
      studentsQuantity: PropTypes.number,
      updaterId: PropTypes.number,
      year: PropTypes.number,
      id: PropTypes.number,
      capacity: PropTypes.number,
      courseId: PropTypes.number,
      filterByStatus: PropTypes.bool,
      active: PropTypes.bool,
    })
  ).isRequired,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ).isRequired,
  team: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ).isRequired,
};

export default reduxForm({
  form: 'SchoolClassSchoolClassFilterForm',
})(withTranslation('common')(SchoolClassFilter));
